import React from 'react';
import logoImg from '../assets/logo.jpeg';

const Loader = ({ text = "Initializing..." }) => {
  return (
    <div className="loader-container">
      <div className="loader-content">
        <div className="loader-logo-wrapper">
          <img src={logoImg} alt="N.D.Tools Logo" className="loader-logo" />
          <div className="loader-spinner"></div>
        </div>
        <p className="loader-text">{text}</p>
      </div>
      <style jsx>{`
        .loader-container {
          display: flex;
          justify-content: center;
          align-items: center;
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: var(--bg-primary, #f4f9ff);
          z-index: 99999;
        }
        .loader-content {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1.5rem;
        }
        .loader-logo-wrapper {
          position: relative;
          width: 100px;
          height: 100px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .loader-logo {
          width: 60px;
          height: 60px;
          object-fit: contain;
          z-index: 2;
          border-radius: 50%;
          background: #fff;
          padding: 5px;
          box-shadow: 0 4px 15px rgba(0,0,0,0.1);
        }
        .loader-spinner {
          position: absolute;
          inset: 0;
          border: 3px solid rgba(10, 102, 255, 0.1);
          border-top: 3px solid var(--accent-color);
          border-radius: 50%;
          animation: spin 1s linear infinite;
          z-index: 1;
        }
        .loader-text {
          font-family: var(--ff-mono);
          font-size: 0.9rem;
          color: var(--text-dim);
          letter-spacing: 0.1em;
          text-transform: uppercase;
          animation: pulse 1.5s ease-in-out infinite;
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @keyframes pulse {
          0%, 100% { opacity: 0.6; }
          50% { opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default Loader;
